// Centralized site data and image assets
// Canonical Setmore booking page (no UTM params).
// Setmore can serve a different/cached rendering path for QR/share UTM links inside
// iframes — we load the exact same URL a direct visitor would, so availability,
// services, durations and times stay in lockstep with the Setmore admin calendar.
export const SETMORE_URL = "https://ttcutsbarbershop.setmore.com";

// Real TTcuts barbershop photos (served from /public/images)
const PHOTO = (name) => `${process.env.PUBLIC_URL || ""}/images/${name}`;

export const IMAGES = {
  logo: PHOTO("ttcuts-logo.png"),
  heroBg: PHOTO("IMG_5896.jpeg"),
  about: PHOTO("IMG_5897.jpeg"),
  gallery: [
    PHOTO("IMG_5898.jpeg"),
    PHOTO("IMG_5899.jpeg"),
    PHOTO("IMG_5900.jpeg"),
    PHOTO("IMG_5901.jpeg"),
    PHOTO("IMG_5902.jpeg"),
    PHOTO("IMG_5903.jpeg"),
    PHOTO("IMG_5896.jpeg"),
  ],
};

export const REVIEWS = [
  {
    rating: 5,
    text:
      "Erittäin taitava ja mukava parturi. Tilat myöskin erittäin viihtyisät!",
    author: "Asiakas",
  },
  {
    rating: 5,
    text:
      "Ylivoimaisesti paras parturi Oulun alueella. Erittäin taitava leikkaaja ja lopputulos aina juuri mitä on halunnut. Tunnelma aivan mahtava.",
    author: "Asiakas",
  },
  {
    rating: 5,
    text: "Todella hyvä leikkaaja, suosittelen kaikille.",
    author: "Asiakas",
  },
  {
    rating: 5,
    text: "Aivan mahtava parturi.",
    author: "Asiakas",
  },
];

export const PRODUCTS = [
  { name: "Bandido Pomade", price: "20€", tag: "Pomade" },
  { name: "Bandido Sea Salt Spray", price: "20€", tag: "Spray" },
  { name: "Bandido Matte Powder Wax", price: "20€", tag: "Wax" },
  { name: "Bandido Skull Powder", price: "20€", tag: "Powder" },
  { name: "Bandido Hair Mousse", price: "20€", tag: "Mousse" },
];

export const CONTACT = {
  phone: "0401664749",
  phoneHref: "tel:+358401664749",
  email: "tuukka.tolli08@gmail.com",
  instagram: "https://instagram.com/ttcuts",
  instagramHandle: "@ttcuts",
  tiktok: "https://tiktok.com/@ttcutsbarbershop",
  tiktokHandle: "@ttcutsbarbershop",
  address: "Kivimaantie 19, Ii Yliranta, Finland",
  mapsEmbed:
    "https://www.google.com/maps?q=Kivimaantie+19,+Ii,+Finland&output=embed",
};
